export default function SidebarToggle({ isOpen, setIsOpen }) {
	return (
		<>
			<button
				onClick={() => setIsOpen(!isOpen)}
				className={
					"absolute top-4 pointer z-10 text-white " +
					(isOpen ? "right-4" : "left-4")
				}
			>
				{isOpen ? "→" : "←"}
			</button>
			<button className="mobile-swipe-btn"></button>
		</>
	);
}
